<template>
  <body>
    <div class="modalContainer active loginModal formsModal">
      <div class="actualModal">
        <a href="#" class="closeModal"><i class="fal fa-times"></i></a>
        <div class="modalBodyOfItem">
          <div class="itemBodyLeftModal">
            <h4>Credit Card Info</h4>
            <div class="inputsContainer">
              <div class="individualInput">
                <h5>Full Name</h5>
                <input v-model="name" type="text" name="" id="" placeholder="" />
              </div>
              <div class="individualInput">
                <h5>Credit Card Number</h5>
                <input v-model="number" type="text" name="" id="" placeholder="" />
              </div>
              <div class="dualInputContainer">
                <div class="individualInput">
                  <h5>Expiration Date</h5>
                  <input v-model="expdate" type="text" name="" id="" placeholder="00/00" />
                </div>
                <div class="individualInput">
                  <h5>Security Code</h5>
                  <input v-model="code" type="text" name="" id="" placeholder="000" />
                </div>
              </div>
            </div>
            <div class="quickCheckout">
              <a href="#">Create Account</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
</template>
<script>
export default {
  data(){
    return{
    code: null,
    number: null,
    expdate: null,
    name: null
  }
  }
}
</script>
